import React from "react";
import "./SegmentedControl.css";

function SegmentedControl({ options, value, onChange, ariaLabel, className = "" }) {
    return (
        <div
            className={`seg-ctrl ${className}`}
            role="radiogroup"
            aria-label={ariaLabel}
        >
            {options.map((opt) => {
                const active = opt.value === value;
                return (
                    <button
                        type="button"
                        key={opt.value}
                        role="radio"
                        aria-checked={active}
                        className={`seg-ctrl__opt focus-ring ${active ? "is-active" : ""}`}
                        onClick={() => onChange?.(opt.value)}
                        title={opt.hint || opt.label}
                    >
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
}

export default SegmentedControl;
